module.exports = __webpack_public_path__ + "static/media/rsz_mutantsr2.e8e47bfd.webp";